import { render, staticRenderFns } from "./StatementsList.vue?vue&type=template&id=23c0866d&scoped=true&"
import script from "./StatementsList.vue?vue&type=script&lang=js&"
export * from "./StatementsList.vue?vue&type=script&lang=js&"
import style0 from "./StatementsList.vue?vue&type=style&index=0&id=23c0866d&scoped=true&lang=scss&"
import style1 from "./StatementsList.vue?vue&type=style&index=1&id=23c0866d&lang=scss&scoped=true&"
import style2 from "./StatementsList.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c0866d",
  null
  
)

export default component.exports